export default __webpack_public_path__ + "static/ESC_Modal_GuardIt_LOGO-2c7647d1de54881654c1d17c778241e0.png";